import { Card } from "@common";
import ClinicVacationSection from "@common/ClinicVacationSection";
import ClinicScheduleOverrideSection from "@common/ClinicScheduleOverrideSection";

export default function ClinicVacationTab({ clinicId }) {
  return (
    <div className="mx-auto w-full max-w-2xl mt-6">
      <Card>
        <div className="mb-1">
          <h2 className="text-base font-bold text-palette-slate-text">Clinic Closures</h2>
          <p className="text-xs text-palette-gray-placeholder mt-0.5">
            Manage clinic-wide holidays and closure periods.
          </p>
        </div>
        <ClinicVacationSection clinicId={clinicId} />
        <ClinicScheduleOverrideSection clinicId={clinicId} />
      </Card>
    </div>
  );
}
